import { useSelector } from 'react-redux';

import { HUB_EVENTS, PRINTER_EVENTS } from '~/main/namespace';
import { LoggerScope } from '~/main/utils/logger';
import { useDeepCompareEffect, useEventListener } from '~/renderer/hooks';
import { useSocket } from '~/renderer/hooks/socket/use-setup-socket';
import { getIsConnected } from '~/renderer/store/connection/selectors';
import { getIsFullscreen, getSelectedDisplay } from '~/renderer/store/displays/selectors';
import { getDefaultPrinters } from '~/renderer/store/printers/selectors';
import { isBrowserCFD, isRenderProcess } from '~/renderer/utils';
import Logger from '~/renderer/utils/logger';
import { HUB_MESSAGES } from '~/types/socket';

import { PRINTER_MESSAGES } from './socket/types';

export const useDevicesToRetail = () => {
  const isConnectedToRetail = useSelector(getIsConnected);
  const defaultPrinters = useSelector(getDefaultPrinters);
  const selectedDisplay = useSelector(getSelectedDisplay);
  const isFullscreen = useSelector(getIsFullscreen);
  const publish = useSocket();
  const isLocalServerConnected = useSelector(
    state => state.connection.localServerStatus === 'connected',
  );

  useEventListener(PRINTER_EVENTS.PRINT_COMPLETED, (_, data) => {
    if (data.isTestPrint) return;
    publish(PRINTER_MESSAGES.PRINT_COMPLETED, data);
  });
  useEventListener(PRINTER_EVENTS.PRINT_ERROR, (_, error) => {
    publish(PRINTER_MESSAGES.PRINT_ERROR, error);
  });

  useEventListener(HUB_EVENTS.RELAY_PUBLISH, (_, { message, data }) => {
    publish(message, data);
  });

  useDeepCompareEffect(() => {
    if (isBrowserCFD && !selectedDisplay) {
      return;
    }

    if (isConnectedToRetail) {
      const devices = {
        ...(isRenderProcess ? { defaultPrinters } : null),
        selectedDisplay: isFullscreen || isBrowserCFD ? selectedDisplay : {},
      };

      const transport = isLocalServerConnected ? LoggerScope.LOCAL_SERVER : LoggerScope.ABLY;

      Logger({ scope: LoggerScope.HUB, transport }).debug({
        msg: 'Send updated devices list to retail',
        ...devices,
      });

      publish(HUB_MESSAGES.DEVICES, devices);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultPrinters, selectedDisplay, isFullscreen, isConnectedToRetail]);

  return {};
};
